import React, { useState } from "react";
import PageTitle from "../api/PageTitle";
import { newsData } from "./doctor/json/index";

const News = () => {
  const [news, setNews] = useState(newsData);
  return (
    <>
      <PageTitle name="News and Updates" link="Home" page="News" />
      <section className="news-wrapper">
        <section className="news-left-section">
          {news.map((curEle) => {
            return (
              <section className="news-container">
                <img src={curEle.img} alt="x-ray" className="news-img" />
                <span className="news-span">
                  <p className="news-admin">{curEle.admin}</p>
                  <p>{curEle.date}</p>
                </span>
                <h2 className="news-h2">{curEle.title}</h2>
                <p className="news-para">{curEle.description}</p>
                <a href="" className="news-btn">
                  {curEle.btn}
                </a>
              </section>
            );
          })}
        </section>
        <section className="news-right-section">
          <div className="news-search">
            <h2>Search Here</h2>
            <input type="text" placeholder="Search here" />
          </div>
          <div className="news-category">
            <h2>Category</h2>
            <span>
              <p>Lorem, ipsum dolor.</p>
              <p>62</p>
            </span>
            <span>
              <p>Lorem, ipsum dolor.</p>
              <p>62</p>
            </span>
            <span>
              <p>Lorem, ipsum dolor.</p>
              <p>62</p>
            </span>
            <span>
              <p>Lorem, ipsum dolor.</p>
              <p>62</p>
            </span>
          </div>
          <div className="archive">
            <h2>Archive</h2>
            <span>
              <p>January</p>
              <p>62</p>
            </span>
            <span>
              <p>February</p>
              <p>62</p>
            </span>
            <span>
              <p>March</p>
              <p>62</p>
            </span>
            <span>
              <p>April</p>
              <p>62</p>
            </span>
            <span>
              <p>May</p>
              <p>62</p>
            </span>
          </div>
          <div className="news-tags">
            <h2>Popular Tags</h2>
            <span>
              <p>one</p>
              <p>Two</p>
              <p>Three</p>
              <p>Four</p>
            </span>
          </div>
        </section>
      </section>
    </>
  );
};

export default News;
